import { withClassName } from '@/common/theme/withClassName';
import type { ButtonProps } from '@soluto-private/mx-asurion-ui-react';
import classNames from 'classnames';
import { ButtonWithAnalytics } from '../ButtonWithAnalytics';
import styles from '../primary-button.module.scss';

export const SecondaryButton = ({ className, ...props }: ButtonProps) => (
  <ButtonWithAnalytics
    className={classNames(styles.button, className)}
    variant="outline"
    {...props}
  />
);

export const RedesignSecondaryButton = withClassName(
  SecondaryButton,
  styles.secondary,
  'RedesignSecondaryButton',
);
